export const TOGGLE_THEME = 'TOGGLE_THEME';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const ONSWATCH = 'ONSWATCH';
